import { r as registerInstance, c as createEvent, h, H as Host } from './index-662ec80e.js';
import { w as waitNextRender, r as resolveNextRender } from './browser-202fc7f4.js';
import { t as tuple } from './types-6f6b2fba.js';
import { p as propCheck, r as runWatchers, h as hasPropError, d as displayPropError } from './propCheck-e7571e3e.js';
import { S as vOneOf, m as vFilename, M as vMaxNumber, b as vMinLength, a1 as vUndefOr, a as vString, Q as vBoolean, O as vInteger, K as vMinNumber, $ as vNullOr, Z as vObjectWith } from './validation-02b8d01d.js';
import { v as vFile } from './types-54e7e023.js';
import { t } from './i18n-939e2dee.js';
import './ethereum-81afa4d8.js';
import './index-750217fe.js';
import './mersenne-twister-c69b8beb.js';
import './quill-8bc04d22.js';
import './browser-3b40537c.js';
import './countries-358acdc0.js';

const mimeTypes = tuple('image/apng', 'image/gif', 'image/jpeg', 'image/png', 'image/svg+xml', 'image/webp');
const extensions = tuple('apng', 'gif', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'webp');
const imageModes = tuple('upload', 'capture', 'both');

const dsInputImageCss = "ds-input-image:not([is-without-styling]){display:block;position:relative}ds-input-image:not([is-without-styling])>input{position:absolute;width:100%;height:100%;z-index:-1;top:0;left:0;border:1px transparent;box-shadow:none;opacity:0}ds-input-image:not([is-without-styling]) label{display:block;margin-bottom:0.25rem;color:var(--coolGrey-700);font-weight:500;font-size:0.88888889rem;line-height:1.56rem}ds-input-image:not([is-without-styling]) .container{border-width:2px;border-style:dashed;border-radius:var(--radius);border-color:var(--grey-600);background-color:white;text-align:center}ds-input-image:not([is-without-styling]) .container .mode-tabs{margin-top:0.5rem !important}ds-input-image:not([is-without-styling]) .container .mode-tabs .mode-tab{padding:0.5rem !important;cursor:pointer;-ms-flex-positive:1;flex-grow:1;font-size:0.88888889rem;line-height:1.56rem;color:var(--grey-900);fill:var(--grey-900)}ds-input-image:not([is-without-styling]) .container .mode-tabs .mode-tab:hover,ds-input-image:not([is-without-styling]) .container .mode-tabs .mode-tab.selected{color:var(--primary);fill:var(--primary);font-weight:500}ds-input-image:not([is-without-styling]) .container .mode-tabs .mode-tab ds-icon{vertical-align:middle}ds-input-image:not([is-without-styling]) .container ds-progress{display:block;margin:1rem !important}ds-input-image:not([is-without-styling]) .help-info,ds-input-image:not([is-without-styling]) .help-error{margin:0.25rem 0;padding:0;line-height:1;width:100%;font-size:0.79012346rem;line-height:1.3rem;color:var(--grey-800)}ds-input-image:not([is-without-styling]) .help-error{color:var(--red-500) !important}ds-input-image:not([is-without-styling]) .preview{min-width:400px;padding:0 1rem 1rem 1rem}ds-input-image:not([is-without-styling]) .preview .preview-clickable{cursor:pointer;margin:0 0 0.5rem 0}ds-input-image:not([is-without-styling]) .preview .preview-clickable p{font-size:0.79012346rem;line-height:1.3rem;color:var(--grey-900);margin:0;font-weight:500;display:block}ds-input-image:not([is-without-styling]) .preview .preview-clickable p+p{color:var(--grey-700);font-weight:normal}ds-input-image:not([is-without-styling]) .preview .preview-image{position:relative;width:fit-content;margin:0 auto}ds-input-image:not([is-without-styling]) .preview .preview-image img,ds-input-image:not([is-without-styling]) .preview .preview-image video{display:none;max-width:400px;max-height:300px;width:auto;height:auto;border:1px solid var(--grey-700)}ds-input-image:not([is-without-styling]) .preview .preview-image ds-button[icon='capture'],ds-input-image:not([is-without-styling]) .preview .preview-image ds-button[mode='text']{display:none;padding:0.5rem 0;margin:0}ds-input-image:not([is-without-styling]) .preview .preview-image ds-button[icon='capture'] button,ds-input-image:not([is-without-styling]) .preview .preview-image ds-button[mode='text'] button{padding:0.5rem 0;height:auto;line-height:1}ds-input-image:not([is-without-styling]) .preview .preview-image ds-button[icon='capture']{padding:1rem 0 0.5rem 0}ds-input-image:not([is-without-styling]) .preview .preview-image ds-button[mode='text']{padding-bottom:0}ds-input-image:not([is-without-styling])[has-value] .preview-clickable{margin-bottom:1rem}ds-input-image:not([is-without-styling])[has-value] .preview-image img{display:inline-block}ds-input-image:not([is-without-styling])[is-being-dropped] .container{background-color:var(--grey-500)}ds-input-image:not([is-without-styling])[mode='capture'][is-being-dropped] .container{background-color:inherit}ds-input-image:not([is-without-styling])[mode='capture'][video-capturing][has-value] .preview{margin-top:1rem}ds-input-image:not([is-without-styling])[mode='capture'][video-capturing][has-value] .preview .preview-clickable p{font-size:0.79012346rem;line-height:1.3rem;color:var(--grey-900);margin:0;font-weight:500;display:block;text-align:center}ds-input-image:not([is-without-styling])[mode='capture'][video-capturing][has-value] .preview .preview-clickable p+p{color:var(--grey-700);font-weight:normal}ds-input-image:not([is-without-styling])[mode='both'] .preview{padding:1rem}ds-input-image:not([is-without-styling])[mode='both'] ds-progress{display:block;margin:2rem 1rem 0 1rem}ds-input-image:not([is-without-styling])[mode='both'] .mode-tabs{border-bottom:2px dashed var(--grey-500);margin-top:0 !important}ds-input-image:not([is-without-styling])[mode='both'] .mode-tabs .mode-tab{padding:1rem 0 !important}ds-input-image:not([is-without-styling])[mode='both'] .mode-tabs .mode-tab ds-icon{margin-right:0.5rem !important}ds-input-image:not([is-without-styling])[mode='both'] .mode-tabs .mode-tab+.mode-tab{margin-left:1rem !important;border-left:2px dashed var(--grey-500)}ds-input-image:not([is-without-styling])[mode='both']:not([has-value]):not([video-capturing]) .preview-clickable{margin:2rem 1rem}ds-input-image:not([is-without-styling])[video-capturing] .preview .preview-image video,ds-input-image:not([is-without-styling])[video-capturing] .preview .preview-image ds-button[icon='capture'],ds-input-image:not([is-without-styling])[video-capturing] .preview .preview-image ds-button[mode='text']{display:block}ds-input-image:not([is-without-styling])[video-capturing] .preview .preview-image img{display:none}ds-input-image:not([is-without-styling])[video-capturing][has-value] ds-button[mode='text']{display:block}ds-input-image:not([is-without-styling])[is-disabled] .mode-tabs .mode-tab,ds-input-image:not([is-without-styling])[is-readonly] .mode-tabs .mode-tab,ds-input-image:not([is-without-styling])[is-uploading] .mode-tabs .mode-tab,ds-input-image:not([is-without-styling])[is-disabled] .preview-clickable,ds-input-image:not([is-without-styling])[is-readonly] .preview-clickable,ds-input-image:not([is-without-styling])[is-uploading] .preview-clickable{cursor:not-allowed}ds-input-image:not([is-without-styling])[is-disabled] .mode-tab:hover,ds-input-image:not([is-without-styling])[is-readonly] .mode-tab:hover,ds-input-image:not([is-without-styling])[is-uploading] .mode-tab:hover{color:var(--grey-900);fill:var(--grey-900)}";

const fileToBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result.toString());
  /* istanbul ignore next */
  reader.onerror = error => reject(error);
});
const DsInputImage = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.dsInput = createEvent(this, "dsInput", 7);
    this.upload = createEvent(this, "upload", 7);
    this.uploadError = createEvent(this, "uploadError", 7);
    this.delete = createEvent(this, "delete", 7);
    this.nextRenderPromises = [];
    this.propError = {};
    this.displayError = false;
    this.validationError = undefined;
    this.injectedError = undefined;
    this.isBeingDropped = false;
    this.modePresenting = 'upload';
    this.videoReady = false;
    this.videoCapturing = false;
    this.name = undefined;
    this.label = undefined;
    this.mode = 'upload';
    this.isDisabled = false;
    this.isReadonly = false;
    this.isWithoutStyling = false;
    this.isRequired = false;
    this.maxsize = undefined;
    this.value = null;
    this.isUploading = false;
    this.progress = undefined;
  }
  watchName() {
    /* istanbul ignore if */
    if (!propCheck(this, 'name', 'string', vMinLength(1)))
      return;
  }
  watchLabel() {
    /* istanbul ignore if */
    if (!propCheck(this, 'label', 'string', vUndefOr(vString)))
      return;
  }
  async watchMode() {
    /* istanbul ignore if */
    if (!propCheck(this, 'mode', imageModes.join(' | '), vOneOf(imageModes)))
      return;
    if (this.mode !== 'both')
      this.modePresenting = this.mode;
  }
  async watchIsDisabled() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isDisabled', 'boolean', vBoolean))
      return;
    if (this.isDisabled)
      this.clear();
    await waitNextRender(this);
    this.runValidation(this.isDisabled ? null : this.value);
  }
  async watchIsReadonly() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isReadonly', 'boolean', vBoolean))
      return;
    await waitNextRender(this);
    this.runValidation(this.value);
  }
  watchIsWithoutStyling() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isWithoutStyling', 'boolean', vBoolean))
      return;
  }
  watchIsRequired() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isRequired', 'boolean', vBoolean))
      return;
    this.runValidation(this.value);
  }
  watchMaxsize() {
    /* istanbul ignore if */
    if (!propCheck(this, 'maxsize', 'string', vUndefOr(v => vInteger(v) || vMinNumber(1)(v))))
      return;
    this.runValidation(this.value);
  }
  async watchValue() {
    /* istanbul ignore if */
    if (!propCheck(this, 'value', 'InputFileValueObject | File | null', vNullOr(v => vFile(v) &&
      vObjectWith({
        name: vString,
        size: vUndefOr(vNullOr(vInteger)),
        type: vUndefOr(vNullOr(vString)),
        url: vUndefOr(vNullOr(vString))
      })(v))))
      return;
    this.injectedError = undefined;
    this.runValidation(this.value);
    if (!this.previewElement)
      return;
    if (!this.validationError) {
      if (this.value instanceof File) {
        this.previewElement.src = await fileToBase64(this.value);
      }
      else if (this.value && this.value.url) {
        this.previewElement.src = this.value.url;
      }
    }
  }
  watchIsUploading() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isUploading', 'boolean', vBoolean))
      return;
    if (this.isUploading)
      this.displayError = false;
    this.runValidation(this.value);
  }
  watchProgress() {
    /* istanbul ignore if */
    if (!propCheck(this, 'progress', 'number<0,100>', vUndefOr(v => vMinNumber(0)(v) || vMaxNumber(100)(v))))
      return;
  }
  async injectError(error) {
    this.injectedError = error;
    this.runValidation(this.value);
    this.displayError = true;
  }
  async hideError() {
    this.injectedError = undefined;
    this.runValidation(this.value);
    this.displayError = false;
  }
  async clear() {
    this.setValue(null);
    this.runValidation(null);
  }
  runValidation(value) {
    if (!this.inputElement)
      return true;
    this.inputElement.setCustomValidity('');
    this.validationError = undefined;
    if (this.isDisabled || this.isReadonly) {
      if (this.dsForm)
        this.dsForm.checkValidity();
      return true;
    }
    let extension = '';
    if (value && value.name && value.name.lastIndexOf('.') !== -1) {
      extension = value.name.substr(value.name.lastIndexOf('.') + 1);
    }
    if (this.isUploading) {
      this.validationError = t('file.uploading');
    }
    else if (this.isRequired && !value) {
      this.validationError = t('file.required');
    }
    else if (value) {
      // sometimes the mimetype is empty string, allow this
      if ((value instanceof File || value.type) && vOneOf(mimeTypes)(value.type)) {
        this.validationError = t('file.mimetype', { mimeTypes: mimeTypes.join(', '), value: value.type });
      }
      else if (vFilename(value.name)) {
        this.validationError = t('file.name', { filename: value.name, value: value.name });
      }
      else if (vOneOf(extensions)(extension)) {
        this.validationError = t('file.extension', { filename: value.name, value: extension, extensions: extensions.join(', ') });
      }
      else if ((value instanceof File || value.size) && this.maxsize && vMaxNumber(this.maxsize)(value.size)) {
        this.validationError = t('file.maxsize', { maxsize: this.maxsize, value: value.size });
      }
    }
    if (this.validationError) {
      this.inputElement.setCustomValidity(this.validationError);
    }
    else if (this.injectedError) {
      this.inputElement.setCustomValidity(this.injectedError);
    }
    if (this.dsForm)
      this.dsForm.checkValidity();
    return !!this.validationError;
  }
  captureEvent(e) {
    e.preventDefault();
    e.stopPropagation();
  }
  /* istanbul ignore next */
  handleBodyDrag(e) {
    this.captureEvent(e);
    e.dataTransfer.dropEffect = 'none';
  }
  handleDrop(e) {
    this.captureEvent(e);
    this.isBeingDropped = false;
    if (this.isDisabled || this.isReadonly || this.isUploading || this.mode === 'capture')
      return;
    this.displayError = true;
    this.setValue(e.dataTransfer.files.length ? e.dataTransfer.files[0] : null);
  }
  setValue(file) {
    this.dsInput.emit(file);
    if (file) {
      if (this.runValidation(file))
        this.uploadError.emit(file);
      else
        this.upload.emit(file);
    }
    else
      this.delete.emit();
    if (this.inputElement)
      this.inputElement.value = null; // clear the input value so it doesn't get emitted accidentally
  }
  async captureMode() {
    /* istanbul ignore next */
    if (this.videoCapturing || this.isDisabled || this.isReadonly || this.isUploading)
      return;
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    const onLoad = () => {
      this.videoReady = true;
      this.videoCapturing = true;
      this.videoElement.removeEventListener('loadeddata', onLoad);
    };
    this.videoElement.addEventListener('loadeddata', onLoad);
    this.videoElement.srcObject = stream;
  }
  async capture() {
    const canvas = document.createElement('canvas');
    canvas.width = this.videoElement.videoWidth;
    canvas.height = this.videoElement.videoHeight;
    canvas.getContext('2d').drawImage(this.videoElement, 0, 0, canvas.width, canvas.height);
    canvas.toBlob((bytes) => {
      const imageFile = new File([bytes], 'capture.jpg', { type: 'image/jpeg' });
      this.setValue(imageFile);
      this.videoCapturing = false;
    }, 'image/jpeg', 0.95);
  }
  connectedCallback() {
    runWatchers(this);
  }
  componentDidLoad() {
    if (!this.inputElement)
      return; // prop error
    this.dsForm = this.inputElement.closest('ds-form');
    this.watchValue(); // run this again so it can set <img> up
    this.runValidation(this.value);
  }
  componentDidRender() {
    resolveNextRender(this);
  }
  disconnectedCallback() {
    if (this.dsForm)
      this.dsForm.checkValidity();
  }
  render() {
    if (hasPropError(this))
      return displayPropError(this);
    const error = this.displayError && (this.injectedError || this.validationError);
    return (h(Host, { class: { error: !!error }, "has-value": this.value ? true : false, "is-being-dropped": this.isBeingDropped, "mode-presenting": this.modePresenting, "video-capturing": this.videoCapturing, onDragEnter: (e) => { this.isBeingDropped = true; this.captureEvent(e); }, onDragLeave: (e) => { this.isBeingDropped = false; this.captureEvent(e); }, onDragOver: /* istanbul ignore next */ (e) => {
        this.isBeingDropped = true;
        if (!this.isDisabled && !this.isReadonly && !this.isUploading && this.mode !== 'capture')
          e.dataTransfer.dropEffect = 'copy';
        else
          e.dataTransfer.dropEffect = 'none';
        this.captureEvent(e);
      }, onDrop: (e) => { this.handleDrop(e); } }, h("input", { ref: el => this.inputElement = el, name: this.name, id: `ds-input-${this.name}`, type: "file", disabled: this.isDisabled, readOnly: this.isReadonly, onInput: (e) => {
        this.displayError = true;
        const target = e.target;
        target.files.length && this.setValue(target.files[0]);
      }, onBlur: () => this.displayError = true, onInvalid: () => this.displayError = true, accept: mimeTypes.join(',') }), this.label && h("label", null, this.label), h("div", { class: "container" }, h("div", { class: "mode-tabs _flex" }, this.mode !== 'capture' &&
      h("div", { class: { 'mode-tab': true, selected: this.modePresenting === 'upload' }, onClick: () => {
          if (this.isDisabled || this.isReadonly || this.isUploading)
            return;
          this.modePresenting = 'upload';
          if (this.mode !== 'both')
            this.inputElement.click();
          else
            this.videoCapturing = false;
        } }, h("ds-icon", { name: "upload", size: "1.6rem" }), this.mode === 'both' ? t('image.upload') : ''), this.mode !== 'upload' &&
      h("div", { class: { 'mode-tab': true, selected: this.modePresenting === 'capture' }, onClick: () => {
          if (this.isDisabled || this.isReadonly || this.isUploading)
            return;
          this.modePresenting = 'capture';
          this.captureMode();
        } }, h("ds-icon", { name: "camera", size: "1.6rem" }), this.mode === 'both' ? t('image.capture') : '')), this.isUploading ? h("ds-progress", { progress: this.progress || 0 }) : '', h("div", { class: "preview" }, h("div", { class: "preview-clickable", onClick: () => {
        if (this.isDisabled || this.isReadonly || this.isUploading)
          return;
        if (this.modePresenting === 'upload')
          this.inputElement.click();
        else
          this.captureMode();
      } }, error && h("div", { class: "help-error" }, error), !this.isUploading && (this.modePresenting === 'upload'
      || (this.modePresenting === 'capture' && !this.videoCapturing)) ? [
      h("p", null, t(`image.${this.modePresenting}Help`)),
      h("p", null, t(`image.${this.modePresenting}HelpSub`))
    ] : ''), h("div", { class: "preview-image" }, h("video", { ref: el => this.videoElement = el, autoplay: "autoplay", onClick: () => this.capture() }), h("ds-button", { icon: "capture", iconSize: "1.25rem", version: "primary", isFullWidth: true, onClick: () => this.capture() }), h("ds-button", { label: "Cancel", mode: "text", version: "monochrome", isFullWidth: true, onClick: () => this.videoCapturing = false }), h("img", { ref: el => this.previewElement = el, src: "", alt: "", loading: "eager" }))))));
  }
  static get watchers() { return {
    "name": ["watchName"],
    "label": ["watchLabel"],
    "mode": ["watchMode"],
    "isDisabled": ["watchIsDisabled"],
    "isReadonly": ["watchIsReadonly"],
    "isWithoutStyling": ["watchIsWithoutStyling"],
    "isRequired": ["watchIsRequired"],
    "maxsize": ["watchMaxsize"],
    "value": ["watchValue"],
    "isUploading": ["watchIsUploading"],
    "progress": ["watchProgress"]
  }; }
};
DsInputImage.style = dsInputImageCss;

export { DsInputImage as ds_input_image };
